import {
  SYNC_PROTOCOL_V1,
  SYNC_PROTOCOL_V2,
  type RemoteSyncRolloutAuthorization,
  type SyncProtocolVersion
} from '../sync/types';

export const syncBuildEnabled = import.meta.env.VITE_SYNC_ENABLED === 'true';

export const resolveSyncTargetProtocolVersion = (
  configuredValue: string | undefined
): SyncProtocolVersion => {
  const value = configuredValue?.trim();
  if (value === undefined || value === '' || value === String(SYNC_PROTOCOL_V1)) {
    return SYNC_PROTOCOL_V1;
  }
  if (value === String(SYNC_PROTOCOL_V2)) return SYNC_PROTOCOL_V2;
  throw new Error(
    'VITE_SYNC_TARGET_PROTOCOL_VERSION inválido. Use somente "1" ou "2"; remova a variável para manter V1.'
  );
};

export const syncTargetProtocolVersion = resolveSyncTargetProtocolVersion(
  import.meta.env.VITE_SYNC_TARGET_PROTOCOL_VERSION
);

export const isEffectiveSyncEnabled = (
  buildEnabled: boolean,
  remoteRollout: RemoteSyncRolloutAuthorization
): boolean => buildEnabled && remoteRollout.status === 'allowed';
